import React, {useCallback} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {FontColor, IconType} from 'types'
import {getWhatsAppLink} from 'utils'
import {Button, Icon, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  max-width: ${convertUnit(295)};
  padding: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`
const StyledInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${convertUnit(8)};
`
const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(20)};
`

const StyledButton = styled(Button)`
  width: 100%;
`
const StyledLink = styled.a`
  text-decoration: none;
  width: 100%;
`

const StyledParagraph = styled(Paragraph)`
  white-space: pre-wrap;
  text-align: left;
`

interface GiftShopTemplateModalMFALockedProps {
  onToggle(): void
}
export default function GiftShopTemplateModalMFALocked({
  onToggle,
}: GiftShopTemplateModalMFALockedProps) {
  const {translate} = useTranslation()

  const handleRenderVCIcon = useCallback((index: number) => {
    let icon: {
      name: IconType
      color: FontColor
    }
    switch (index) {
      case 0:
        icon = {name: 'padlock', color: 'primary_5'}
        break
      case 1:
        icon = {name: 'whatsapp-ol', color: 'success_5'}
        break
      default:
        icon = {name: 'padlock', color: 'primary_5'}
    }
    return icon
  }, [])

  return (
    <StyledModal visible onBackdropPress={onToggle}>
      <Paragraph fontSize="xl" fontWeight="bold">
        {translate('giftShop:settingAuthAppRecoveryLockedTitle')}
      </Paragraph>
      {Array.from({length: 2}).map((_, index) => (
        <StyledInfo key={index.toString()}>
          <Icon
            size={32}
            color={handleRenderVCIcon(index).color}
            type={handleRenderVCIcon(index).name}
          />
          <StyledParagraph fontSize="m" fontWeight="medium">
            {translate('giftShop:settingAuthAppRecoveryLockedDesc', {
              context: `${index + 1}`,
            })}
          </StyledParagraph>
        </StyledInfo>
      ))}
      <StyledButtonContainer>
        <StyledLink
          href={`${getWhatsAppLink()}?text=${translate(
            'giftShop:settingAuthAppRecoveryLockedWATemplate',
          )}`}
          target="_blank">
          <StyledButton
            label={translate('giftShop:addBankAccountVideoCallButton')}
            className="pressable"
            onClick={onToggle}
          />
        </StyledLink>
        <StyledButton
          label={translate('global:cancel')}
          color="primary_5"
          backgroundColor="white_3"
          className="pressable"
          onClick={onToggle}
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
